export default "__VITE_ASSET__hYta6738__"